var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible && _vm.date)?_c('div',[_vm._v(_vm._s(("Time Left: " + (("0" + _vm.date.hours).slice(-2)) + ":" + (("0" + _vm.date.minutes).slice(-2)) + ":" + (("0" + _vm.date.seconds).slice(-2)))))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }